<div class="field-form-control" *ngIf="control">
  <label [for]="id" *ngIf="label !== ''" class="form-label" [style.color]="labelColor" [class.required]="isRequired">{{
    label
  }}</label>
  @if (type===InputType.NUMBER) {
    <input class="form-control"
      [required]="isRequired"
      [id]="id"
      [type]="type"
      [minlength]="minLength()"
      (input)="setMaxLengthNumberInput($event);"
      [placeholder]="placeholder"
      [formControl]="control"
      autocomplete="off"
      (blur)="onBlur($event)"
    />
  } @else {
    <input class="form-control"
      [required]="isRequired"
      [id]="id"
      [type]="type"
      [maxlength]="maxLength()"
      [minlength]="minLength()"
      [placeholder]="placeholder"
      [formControl]="control"
      autocomplete="off"
      (input)="transformInput($event)"
      (blur)="onBlur($event)"
    />
  }
  
  <app-validation-errors *ngIf="control.touched || errorMessage.length > 0"
    [customErrorMessages]="customErrorMessages"
    [errors]="control.errors"
    [customSingleErrorMessage]="errorMessage"
  >
  </app-validation-errors>
</div>
